<template>
  <!--
    TkTabs が activeTabIndex をプロパティとして正しく扱っていないので、その部分だけ書き換えた
    本来であれば
      見た目に関するスタイルのカプセル化
      子要素として想定している TkTab の data を直接書き換えるような設計を改める
    といったことをし、コンポーネントとして適切な形を目指した方が良い
  -->
  <div>
    <ul :class="navTabsClass">
      <li
        v-for="(tab, idx) in tabs"
        :key="`tktab-navItem__${idx}`"
        :class="[navItemClass, { [activeClass]: idx === activeTabIndex }]"
        @click="selectTab(idx)"
      >
        <slot
          name="title"
          :title="tab.title"
          :tab-index="idx"
          :disabled="tab.disabled"
        >
          {{ tab.title }}
        </slot>
      </li>
    </ul>
    <div :class="contentClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TkDeclarativeTabs',
  props: {
    navTabsClass: {
      type: String,
      default: '',
    },
    activeClass: {
      type: String,
      default: 'active',
    },
    contentClass: {
      type: [Array, String],
      default: null,
    },
    navItemClass: {
      type: String,
      default: '',
    },
    activeTabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedIndex: -1,
      tabs: [],
    }
  },
  watch: {
    activeTabIndex(val) {
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === val
      })
    },
  },
  mounted() {
    this.tabs = this.$children.filter((child) => child._isTab)
    this.tabs.forEach((tab, index) => {
      tab.isActive = index === this.activeTabIndex
    })
  },
  methods: {
    selectTab(i) {
      const targetTab = this.tabs[i]
      if (targetTab.disabled || this.selectedIndex === i) return false
      this.selectedIndex = i
      this.$emit('select-tab', {
        tabIndex: this.selectedIndex,
        title: targetTab.title,
      })
    },
  },
}
</script>
